require('sass/blocks/geoaddress/geosuggest.scss');
require('sass/blocks/geoaddress/geoaddress.scss');

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

const Geosuggest = require('react-geosuggest').default;

const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');

const { Errors } = require('react-redux-form');
const formActions = require('react-redux-form').actions;
const optionsActions = require('actions/optionsActions');

const SuggestionParser = require('utilities/SuggestionParser');
const { getReferenceCodeByCountry } = require('utilities/multiLanguageHelper');
import { formatText, FormattedText } from 'core/i18n';
//const { recordError } = require('utilities/uTagging');
const { intersect } = require('utilities/ArrayUtils/ArrayUtils');

const LoadingIcon = require('assets/icons/icon-animated-ring.svg');

class GeoAddress extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            processing: false,
            hidden: true,
            showDisclaimer: false,
            showNoResultsMessage: false,
            value: '',
            classFocus: false,
            showExample: true,
        };

        this.handleOnSuggestChange = this.handleOnSuggestChange.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnSuggestSelect = this.handleOnSuggestSelect.bind(this);
        this.handleOnSuggestNoResults = this.handleOnSuggestNoResults.bind(this);
        this.getRef = this.getRef.bind(this);
        this.handleShowFields = this.handleShowFields.bind(this);
        this.setChildrenReference = this.setChildrenReference.bind(this);
        this.renderSuggestPrediction = this.renderSuggestPrediction.bind(this);
    }

    UNSAFE_componentWillMount() {
        if (this.props.provinces.size === 0 || this.props.roads.size === 0) {
            this.props.optionsActions.getAddresses();
        }
        const cosos = this.getRequestedModelKeys().some(x => x.props.value !== '');
        const filled = this.props.isFilled();
        if (cosos && filled) {
            this.setState({ hidden: false, value: this.props.value });
        }
    }

    renderDisclaimer() {
        const { userProfile } = this.props;
        let disclaimer;

        if (!this.state.showDisclaimer) {
            return null;
        }

        if (userProfile.openDebitCard) {
            disclaimer = 'addressAutoComplete-disclaimer';
        } else {
            disclaimer = 'addressAutoComplete-disclaimerNotDebit';
        }

        return (
            <div className="form__address-autocomplete__disclaimer form__address-autocomplete__position">
                <p className="font-paragraph2">
                    <i className="icons icons--icon-warning-2"></i>
                    <FormattedText value={disclaimer} />
                </p>
            </div>
        );
    }

    getChildren() {
        // Retrieving all children and injecting props
        return React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                baseModelDescriptor: this.props.baseModelDescriptor,
                baseModelForm: this.props.baseModelForm,
                formActions: this.props.formActions,
            });
        });
    }

    handleOnSuggestChange(search) {
        //Muestra el disclaimer si esta vacio y guarda el valor de la busqueda
        const newState = { value: search };
        if (search && search.length > 0) {
            newState.showDisclaimer = false;
            newState.showNoResultsMessage = false;
        } else if (this.state.showDisclaimer === false) {
            newState.showDisclaimer = true;
        }
        this.setState(newState);
    }

    handleOnFocus() {
        this.setState({ showDisclaimer: true, showNoResultsMessage: false, showExample: false });
        this.props.formActions.setValidity(`${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`, {
            required: true,
        });
        this.changeClassFocus(true);
    }

    handleOnBlur() {
        this.setState({ showDisclaimer: false, showExample: true });
        this.changeClassFocus(false);
    }

    renderErrors(props) {
        return <div className="form__field_error">{props.children}</div>;
    }

    getRequestedModelKeys() {
        return React.Children.toArray(this.props.children).reduce((acc, child) => {
            if (child.type.displayName === 'GeoRowGroup') {
                return acc.concat(child.props.children);
            }

            return acc.concat(child);
        }, []);
    }

    handleOnSuggestSelect(suggestion) {
        const filled = this.props.isFilled();
        const { language, fieldsToResetIfNull } = this.props;

        if (
            !filled &&
            (!suggestion || !suggestion.description || !suggestion.gmaps || !suggestion.gmaps.address_components)
        ) {
            this.setState({ hidden: true, showNoResultsMessage: true, showExample: true });
            this.props.formActions.setValidity(`${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`, {
                required: false,
            });

            return;
        }
        if (
            filled &&
            (!suggestion || !suggestion.description || !suggestion.gmaps || !suggestion.gmaps.address_components)
        ) {
            this.setState({ hidden: false, showNoResultsMessage: false, showExample: false });

            return;
        }
        this.changeClassFocus(false);
        const description =
            language === 'es' ? suggestion.description.replace('Spain', 'España') : suggestion.description;
        this.props.formActions.change(`${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`, description);
        this.props.onUpdate && this.props.onUpdate(this.props.baseModelProperty, description);
        this.props.formActions.setValidity(`${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`, {
            required: true,
        });

        this.setState({ hidden: false, showDisclaimer: false, showNoResultsMessage: false, processing: true }, () => {
            // DISCLAIMER: Futuro mantenedor de este codigo: Por favor lea la siguiente informacion si necesita entender el siguiente codigo.
            // IMPORTANTE: A continuacion se vera una serie de setTimeouts cuya duracion es de 0ms, esto tiene una razon de ser especial.
            //             Escribi una explicacion exhaustiva de los beneficios y lo que se intenta conseguir en un archivo markdown
            //             ubicado en: [project root]/docs/JavascriptAsyncEventDrivenModel.md
            setTimeout(() => {
                const parsedResults = SuggestionParser(
                    this.props.provinces.toJS(),
                    this.props.roads.toJS(),
                    suggestion.gmaps.address_components
                );

                if (parsedResults) {
                    const parsedModelKeys = [...Object.keys(parsedResults), ...fieldsToResetIfNull];

                    const requestedModelKeys = this.getRequestedModelKeys().map(child => {
                        return {
                            baseModelProperty: child.props.baseModelProperty,
                            gmapsType: child.props.gmapsType,
                        };
                    });

                    const commonModelKeys = intersect(
                        requestedModelKeys,
                        parsedModelKeys,
                        (rm, pm) => rm.gmapsType === pm
                    );

                    commonModelKeys.forEach(key => {
                        this.props.formActions.reset(`${this.props.baseModelDescriptor}.${key.baseModelProperty}`);
                    });

                    this.props.formActions.change(
                        `${this.props.baseModelDescriptor}.${`${this.props.baseModelProperty}Filled`}`,
                        false
                    );
                    this.setState({ processing: false }, () => {
                        setTimeout(() => {
                            commonModelKeys.forEach(key => {
                                this.props.formActions.change(
                                    `${this.props.baseModelDescriptor}.${key.baseModelProperty}`,
                                    parsedResults[key.gmapsType]
                                );
                            });

                            this.props.formActions.change(
                                `${this.props.baseModelDescriptor}.${`${this.props.baseModelProperty}Filled`}`,
                                true
                            );
                        }, 0);
                    });
                }
            }, 0);
        });
    }

    getRef(ref) {
        if (ref) {
            this.reference = ref;
        }
    }

    handleShowFields() {
        this.setState({ hidden: false, showDisclaimer: false, showNoResultsMessage: false });
        this.props.formActions.change(
            `${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`,
            this.state.value
        );
        this.props.onUpdate && this.props.onUpdate(this.props.baseModelProperty, this.state.value);
        this.props.formActions.setValidity(`${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`, {
            required: true,
        });

        // DISCLAIMER: Futuro mantenedor de este codigo: Por favor lea la siguiente informacion si necesita entender el siguiente codigo.
        // IMPORTANTE: A continuacion se vera una serie de setTimeouts cuya duracion es de 0ms, esto tiene una razon de ser especial.
        //             Escribi una explicacion exhaustiva de los beneficios y lo que se intenta conseguir en un archivo markdown
        //             ubicado en: [project root]/docs/JavascriptAsyncEventDrivenModel.md
        setTimeout(() => {
            if (this.childrenRef) {
                const select = this.childrenRef.querySelector("input[role='combobox'][value='']");
                const element = this.childrenRef.querySelector("input[type='text'][value='']");
                if (select) {
                    select.focus();
                } else if (element) {
                    element.focus();
                }
            }
        }, 0);
    }

    handleOnSuggestNoResults(search) {
        if (search && search.length > 0) {
            if (!this.state.showDisclaimer) {
                this.setState({ showNoResultsMessage: true, hidden: true });
            }
        }
    }

    setChildrenReference(ref) {
        if (ref) {
            this.childrenRef = ref;
        }
    }

    renderEmptyResults() {
        if (!this.state.showNoResultsMessage) return null;

        return (
            <div style={{ position: 'relative' }}>
                <ul className="prospects-geoaddress--no-results">
                    <li>
                        {formatText('addressAutoComplete-noResults')}
                        <a
                            href="#"
                            onClick={event => {
                                event.preventDefault();
                                this.handleShowFields();
                            }}
                        >
                            {formatText('addressAutoComplete-manuallyComplete')}
                        </a>
                    </li>
                </ul>
            </div>
        );
    }

    renderChildren() {
        const children = this.getChildren();
        if (this.state.hidden && !this.props.showChildren) return null;
        if (this.state.processing) {
            return (
                <div className="prospects-geoaddress--loading">
                    <img src={LoadingIcon} alt="Loading Address" />
                </div>
            );
        }

        return children;
    }

    renderLabel() {
        return this.props.label ? <label htmlFor="">{this.props.label}</label> : null;
    }

    renderExample(hasError) {
        let result = null;
        const exampleClass = classNames('prospects-geoaddress--example', {
            'prospects-geoaddress--example-error': hasError,
        });

        if (this.state.showExample) {
            result = <div className={exampleClass}>{formatText('field-addressExample')}</div>;
        }

        return result;
    }

    changeClassFocus(change) {
        this.setState({
            classFocus: change,
        });
    }

    renderSuggestPrediction(suggest) {
        const { language } = this.props;
        const label = language === 'es' ? suggest.description.replace('Spain', 'España') : suggest.description;

        return label;
    }

    render() {
        const classFocus = this.state.classFocus;
        const { baseModelForm, baseModelProperty, hiddenSearch } = this.props;
        const hasError = !(baseModelForm?.fields?.[baseModelProperty]?.valid ?? true);
        const geoAddressClassNames = classNames('form__input', {
            'form__input--hidden': hiddenSearch,
            'form__input--error': hasError,
            'valid-error': hasError,
            'form__input--focus': classFocus,
        });
        const geoSubfieldsClassNames = classNames({ 'prospects-geoaddress--subfields': !hiddenSearch });

        return (
            <div className="prospects-geoaddress" ref={this.getRef} id={this.props.id}>
                <div className="form__input">{this.renderLabel()}</div>
                <div className={geoAddressClassNames} ref={this.props.refProp}>
                    <Geosuggest
                        onChange={this.handleOnSuggestChange}
                        onFocus={this.handleOnFocus}
                        onBlur={this.handleOnBlur}
                        onSuggestSelect={this.handleOnSuggestSelect}
                        country={getReferenceCodeByCountry()}
                        onSuggestNoResults={this.handleOnSuggestNoResults}
                        getSuggestLabel={this.renderSuggestPrediction}
                        initialValue={this.props.value}
                        placeholder={formatText('addressAutoComplete-viewSuggestSm')}
                        disabled={this.props.disabled}
                    />
                    <Errors
                        model={`${this.props.baseModelDescriptor}.${this.props.baseModelProperty}`}
                        messages={{
                            required: formatText('validation-addressRequired'),
                        }}
                        component={this.renderErrors}
                    />
                    {this.renderExample(hasError)}
                </div>
                {this.renderEmptyResults()}
                {this.renderDisclaimer()}
                <div className={geoSubfieldsClassNames} ref={this.setChildrenReference}>
                    {this.renderChildren()}
                </div>
            </div>
        );
    }
}

GeoAddress.propTypes = {
    label: PropTypes.string,
    children: PropTypes.any,
    disabled: PropTypes.bool,
    baseModelDescriptor: PropTypes.string.isRequired,
    baseModelProperty: PropTypes.string.isRequired,
    baseModelForm: PropTypes.object.isRequired,
    value: PropTypes.string,
    onUpdate: PropTypes.func,
    isFilled: PropTypes.func,
    language: PropTypes.string,
    hiddenSearch: PropTypes.bool,
    showChildren: PropTypes.bool,
    fieldsToResetIfNull: PropTypes.array,
};

GeoAddress.defaultProps = {
    disabled: false,
    messagesError: { required: formatText('validation-fieldRequired'), valid: formatText('validation-text') },
    addressExample: formatText('field-addressExample'),
    addressExampleClass: 'addrees-example',
    language: 'es',
    hiddenSearch: false,
    showChildren: false,
    fieldsToResetIfNull: ['street_number'],
};

module.exports = connect(
    state => ({
        provinces: state.options.get('cities'),
        roads: state.options.get('typesOfRoads'),
        userProfile: state.userProfile,
    }),
    dispatch => ({
        optionsActions: bindActionCreators(optionsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
    })
)(GeoAddress);
